export default __webpack_public_path__ + "static/media/create-trustline-step-3@2x.213a6388.png";